import { createSlice } from "@reduxjs/toolkit";
import getMeristemDefaultValue from "../../meristemContext/meristemContextDefaults";

const extractData = (data) => {
  return {
    device_brand: data.device_brand,
    device_family: data.device_family,
    device_is_mobile: data.device_is_mobile,
    device_os: data.device_os,
  };
};

const deviceInformationSlice = createSlice({
  name: "deviceInformation",
  initialState: extractData(getMeristemDefaultValue()),
  reducers: {
    setDeviceInformation(state, action) {
      return extractData(action.payload) || state;
    },
  },
});

export const { setDeviceInformation } = deviceInformationSlice.actions;

export default deviceInformationSlice.reducer;
